import React, { useState } from 'react';
import api from '../services/api'; // Yeni api.js dosyamızı import ettik
import '../styles/ResetPassword.css';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [resetSuccess, setResetSuccess] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [apiError, setApiError] = useState('');

  const validateEmail = (email) => {
    const validDomains = [
      '@gmail.com', '@gmail.com.tr',
      '@hotmail.com', '@hotmail.com.tr',
      '@outlook.com', '@outlook.com.tr',
      '@yahoo.com', '@yahoo.com.tr',
      '@icloud.com', '@icloud.com.tr',
      '@yandex.com', '@yandex.com.tr'
    ];
    
    const domain = email.substring(email.indexOf('@'));
    return validDomains.includes(domain.toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(email)) {
      setEmailError('Geçersiz e-posta adresi. Lütfen mail adresinizi kontrol edin.');
      return;
    }
    setEmailError('');
    setApiError(''); // API hatasını sıfırla

    try {
      const response = await api.post('/reset-password/send-reset-email', { email });
      if (response.status === 200) {
        setResetSuccess(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Error sending reset email:', error);
      setApiError('Şifre sıfırlama bağlantısı gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <h2>Şifre Sıfırlama</h2>

        {resetSuccess ? (
          <div className="success-message">
            <h3>Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.</h3>
            <p>Lütfen e-postanızı kontrol edin.</p>
            <div className="reset-instructions">
              <p>Şifrenizi sıfırlamak için:</p>
              <ol>
                <li>E-postanızdaki şifre sıfırlama bağlantısına tıklayın</li>
                <li>Açılan sayfada yeni şifrenizi belirleyin</li>
                <li>Yeni şifrenizle giriş yapabilirsiniz</li>
              </ol>
              <p className="note">Not: Şifre sıfırlama bağlantısı 1 saat süreyle geçerlidir.</p>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-description">
              <p>Şifrenizi sıfırlamak için kayıtlı e-posta adresinizi girin.</p>
              <p>Size şifre sıfırlama bağlantısı göndereceğiz.</p>
            </div>

            <input
              type="email"
              placeholder="E-posta adresiniz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {emailError && <div className="error-message">{emailError}</div>}
            {apiError && <div className="error-message">{apiError}</div>}

            <button type="submit" className="reset-button">
              Şifre Sıfırlama Bağlantısı Gönder
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;